import * as React from 'react';
import { cn } from '../../lib/utils';
import { formControlClasses } from '../../config/themeClasses';

const Input = React.forwardRef(({ className, type, ...props }, ref) => (
  <input
    type={type}
    className={cn(formControlClasses.input, className)}
    ref={ref}
    {...props}
  />
));
Input.displayName = 'Input';

export { Input };
